<template>
    <div>
        <h3 class="text-center">วันลา</h3>
        <br/>
        <b-row class="form-group">
            <b-col sm="4" class="col-sm-4 text-right">พนักงาน</b-col>
            <b-col sm="6" class="col-sm-6">
                <div v-if="form.employee">
                    <input class="form-control" v-model="form.employee.name" disabled/>
                </div>
            </b-col>
        </b-row>
        <b-row class="form-group">
            <b-col sm="4" class="col-sm-4 text-right">ประเภทการลา</b-col>
            <b-col sm="6" class="col-sm-6">
                <b-form-select v-model="form.leave_type"
                               :options="optionLeaveDay">
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="form-group" v-if="form.leave_type == 8">
            <b-col sm="4" class="col-sm-4 text-right">เวลาที่เฮียปล่อยกลับ</b-col>
            <b-col sm="6" class="col-sm-6">
                <date-picker
                    v-model="form.time"
                    type="time"
                    :lang="lang"
                    format="HH:mm"
                    placeholder="เวลาเฮียปล่อยกลับบ้าน"
                    confirm>
                </date-picker>
            </b-col>
        </b-row>
        <b-row class="form-group">
            <b-col sm="4" class="col-sm-4 text-right">จำนวนชม.ที่ลากิจ</b-col>
            <b-col sm="6" class="col-sm-6">
                <b-form-select v-model="form.leave_time_type"
                               :options="leave_time_type">
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="form-group">
            <b-col sm="4" class="col-sm-4 text-right">วันที่</b-col>
            <b-col sm="6" class="col-sm-6">
                <date-picker
                        v-model="form.start_date"
                        class="w-100"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่เริ่มต้น">
                </date-picker>
            </b-col>
        </b-row>
        <b-row class="form-group">
            <b-col sm="4" class="col-sm-4 text-right">ถึง</b-col>
            <b-col sm="6" class="col-sm-6">
                <date-picker
                        v-model="form.end_date"
                        class="w-100"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่สิ้นสุด">
                </date-picker>
            </b-col>
        </b-row>
        <div class="col text-center" v-if="form.id">
            <b-form-radio-group
                    v-model="form.status"
                    :options="status">
            </b-form-radio-group>
        </div>
        <br/>
        <div class="col text-center">
            <button type="button"
                    @click="submit"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp&nbsp
            <button type="button"
                    @click="cancel"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
<!--        <pre class="alert-primary">{{leave_time_type}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";

    export default {
        name: "work-schedule-modal",
        components:{
            Multiselect,
            DatePicker
        },
        created(){
            this.$store.dispatch("LeaveDay/setLeaveDayAll");
            this.$store.dispatch("LeaveDay/getLeaveHour").then(res=>{
                this.leave_time_type = res.map(data=>({
                        text:  data.name,
                        value: data.id
                    }))
            })
        },
        data(){
          return{
              leave_time_type : [],//เวลารายชม.
              selecttime :[
                  {text:"เลือกช่วงเวลา" ,value:""},
                  {text:"เต็มวัน" ,value:1},
                  {text:"ครึ่งวัน" ,value:2},
              ],
              status:[
                  {text:"ปฏิเสธ" ,value:0},
                  {text:"อนุมัติ" ,value:1},
              ],
              changeFormat: {
                  stringify: (date) => {
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },

            }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.WorkScheduleEmployee.work_schedule
                },
                optionLeaveDay:state=>{
                    return [
                        {
                          value:"",
                          text:"เลือกวันลา"
                        },
                        ...state.LeaveDay.leaveDayAll.map(data=>({
                            text:  data.name,
                            value: data.id
                        })),
                    ];
                },
            })
        },
        methods:{
            submit(){
                if(!this.form.leave_type){
                    alert("กรุณาเลือกประเภทวันลา")
                }
                else if(!this.form.employee){
                    alert("กรุณาเลือกพนักงาน")
                }
                else if(!this.form.start_date){
                    alert("กรุณาเลือกวันเริ่มต้น")
                }
                else if(!this.form.end_date){
                    alert("กรุณาเลือกวันสิ้นสุด")
                }
                else{
                    this.form.employee_id = this.form.employee.id;
                    this.form.start_date = moment(this.form.start_date).format("YYYY-MM-DD");
                    this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");
                    console.log(this.form);
                    this.$emit("submit",this.form);
                }
            },
            cancel(){
                this.$emit("submit",0)
            }
        }
    }
</script>

<style scoped>

</style>
